import Estudios from "./Estudios";
export default Estudios;